import * as EventManager from "../events/event-manager.js";

/**
 * Citizen Referral Events
 */
export const CitizenReferralEvents = (function () {

    let eventManager;

    let init =  function () {

        eventManager = EventManager.EventManager("Citizen", CitizenReferralEvents);
        eventManager.addEventListeners();
  
    }


    ////////Functions required for use of Events module//////////

    /**
     * Defines how events are to be handled in this context for use in Events module
     */
    let eventHandlers = {
        //@TODO add functions here that tell the event-manager module what to do in this particular view when an appointment is
        //accepted, declined, deleted
    }
   //event manager uses this to link events to this context i.e. the referral
    let getReferralID = function() {
        return $('#referral-id').data('referral');
    }
    
    return {
      init : init,
      eventHandlers : eventHandlers,
      getContextID : getReferralID
    }
  
}());